import {
  InternalAccount,
  PayoutDestinationType,
  PayoutSettings
} from "@wingspanhq/wingspan-api-sdk";
import { selectorPayoutSettingsDefaultDestination } from "@selectors/selectorPayoutSettingsDefaultDestination";

export const selectorIsPlatformBalanceAccount = (
  internalAccount: InternalAccount,
  payoutSettings?: PayoutSettings
) => {
  if (!payoutSettings) {
    return false;
  }

  const defaultDestination =
    selectorPayoutSettingsDefaultDestination(payoutSettings);
  if (defaultDestination?.type !== PayoutDestinationType.INTERNAL_ACCOUNT) {
    return false;
  }
  return internalAccount.id === defaultDestination?.id;
};
